import * as React from 'react';

const ValeoSvgIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 48 21"
    {...props}
  >
    <path
      fill="#4E6B7C"
      d="M46.728 15.17c-4.01-.297-8.998-.54-14.45-.54-8.343 0-17.766.568-26.36 2.334-1.439-1.804-3.193-3.225-5.88-4.346l-.038.08c2.376 2.564 3.895 4.78 4.974 7.954 12.043-4.465 27.17-5.288 38.586-5.288 1.092 0 2.134.015 3.143.024z"
    />
    <path
      fill="#82E600"
      d="M34.19 7.062c.065-.308.12-.568.12-.925 0-.7-.444-.983-.909-.983-.77 0-1.167.452-1.349 1.908h2.14zm-15.2 3.505c-.236.168-.585.362-.973.362-.739 0-.844-.62-.844-1.352 0-.86.235-2.399.492-3.004.39-.928.922-1.186 1.779-1.186.025 0 .09 0 .18.013l-.637 5.167zm25.156-2.114c-.275 2.5-.653 3.017-1.374 3.017-.663 0-.922-.48-.922-1.524 0-.448.052-1.083.13-1.736.272-2.503.65-3.016 1.374-3.016.662 0 .924.474.924 1.518 0 .454-.053 1.084-.13 1.741m-17.24 4.743h-3.607L24.935 0h3.607l-1.639 13.198zm7.337-2.292c.725 0 1.7-.169 2.466-.387l-.442 2.396c-.912.23-2.193.36-3.338.36-3.644 0-4.659-1.573-4.659-3.637 0-5.27 2.286-6.469 5.426-6.469 2.466 0 3.997 1.186 3.997 3.453 0 .992-.202 1.883-.347 2.503h-5.426c0 1.134.375 1.778 2.323 1.778M20.053 3.25c-2.518 0-3.88.477-4.983 1.65-1.052 1.111-1.61 3.066-1.61 5.144 0 1.804.455 3.3 2.701 3.3 1.024 0 1.921-.39 2.753-.869h.038l-.093.722h3.415l1.22-9.887a87 87 0 0 0-3.44-.065M48 6.75c0-2.552-1.661-3.584-4.454-3.584-3.373 0-5.426 1.538-5.426 6.744 0 2.55 1.664 3.584 4.457 3.584 3.37 0 5.423-1.498 5.423-6.744M12.214 0c-.83 3.093-1.973 6.189-3.44 9.294H8.75C8.362 6.772 8.165 3.135 8.165 0h-4.18c.128 4.948.997 9.319 1.974 13.198H9.98C12.25 9.125 14.38 4.745 16.029 0h-3.817z"
    />
  </svg>
);
export default ValeoSvgIcon;
